// extracted by mini-css-extract-plugin
export default {"fieldList":"HousingForm_fieldList__j2ELk"};